import { render, staticRenderFns } from "./seniorDismissalMaster.vue?vue&type=template&id=3c765d0a"
import script from "./seniorDismissalMaster.vue?vue&type=script&lang=js"
export * from "./seniorDismissalMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c765d0a')) {
      api.createRecord('3c765d0a', component.options)
    } else {
      api.reload('3c765d0a', component.options)
    }
    module.hot.accept("./seniorDismissalMaster.vue?vue&type=template&id=3c765d0a", function () {
      api.rerender('3c765d0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/com/seniorDismissalMaster.vue"
export default component.exports